module.exports = __webpack_public_path__ + "ae21cb8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon_email.png
// module id = 1581
// module chunks = 0